import { theme } from '@garnish/constants';

// ─── Location Results Card ───────────────────────────────────────────────────

export const LOCATION_CARD_IMG_BG_COLOR = theme.colors.OPACITY.QUINOA.DARKER;

// ─── Location Results ────────────────────────────────────────────────────────

export const LOCATION_RESULTS_THEME_BG_COLOR = theme.colors.APP_BACKGROUND;
export const LOCATION_RESULTS_BOTTOM_MARGIN_XS_UPDATE = theme.spacing[8];
export const LOCATION_SELECTION_UI_BOX_SHADOW_XS = '0px 4px 20px 4px rgba(0, 0, 0, 0.14)';
export const LOCATION_RESULTS_CARD_HEIGHT_PADDING_VERTICAL_XS = theme.spacing['4'];
export const LOCATION_RESULTS_CARD_HEIGHT_PADDING_VERTICAL_SM = 12;
export const LOCATION_RESULTS_CARD_DISCLAIMER_HEIGHT = 44;
